import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useZustandStore } from 'zustandGlobalStore'

export const useScrollToTopByRouteChange = (): void => {
  const { pathname } = useLocation()
  const leadId = useZustandStore((state) => state.lead?.id)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  useEffect(() => {
    if (!leadId || !window.history.scrollRestoration) return
    window.history.scrollRestoration = 'manual'
  }, [leadId])
}
